import { Transition } from '@headlessui/react'
import { CheckCircleIcon, XCircleIcon, InformationCircleIcon } from '@heroicons/react/24/outline'
import { XMarkIcon } from '@heroicons/react/20/solid';
export function SuccessNotification({ showSuccessBox, successMsg, setShowSuccessBox }) {
    return (
    <div aria-live="assertive" className={`pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-40 ${showSuccessBox === true ? "bg-white/50" : ""} `}>
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
            <Transition show={showSuccessBox}>
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in data-closed:data-enter:sm:translate-x-2 data-closed:data-enter:sm:translate-y-0">
                <div className="p-4">
                <div className="flex items-start">
                    <div className="shrink-0">
                    <CheckCircleIcon aria-hidden="true" className="size-6 text-green-400" />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">{successMsg}</p>
                    </div>
                    <div className="ml-4 flex shrink-0">
                    <button
                        type="button"
                        onClick={() => {
                        setShowSuccessBox(false)
                        }}
                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    >
                        <span className="sr-only">Close</span>
                        <XMarkIcon aria-hidden="true" className="size-5" />
                    </button>
                    </div>
                </div>
                </div>
            </div>
            </Transition>
        </div>
    </div>
    )
}
export function ErrorNotification({ showErrorBox, errorMsg, setShowErrorBox }) {
    return (
    <div aria-live="assertive" className={`pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-40 ${showErrorBox === true ? "bg-white/50" : ""} `}>
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
            <Transition show={showErrorBox}>
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in data-closed:data-enter:sm:translate-x-2 data-closed:data-enter:sm:translate-y-0">
                <div className="p-4">
                <div className="flex items-start">
                    <div className="shrink-0">
                    <XCircleIcon aria-hidden="true" className="size-6 text-red-400" />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">{errorMsg}</p>
                    </div>
                    <div className="ml-4 flex shrink-0">
                    <button
                        type="button"
                        onClick={() => {
                        setShowErrorBox(false)
                        }}
                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    >
                        <span className="sr-only">Close</span>
                        <XMarkIcon aria-hidden="true" className="size-5" />
                    </button>
                    </div>
                </div>
                </div>
            </div>
            </Transition>
        </div>
    </div>
    )
}
export function InfoNotification({ showInfoBox, infoMsg, setShowInfoBox }) {
    return (
    <div aria-live="assertive" className="pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-40">
        <div className="flex w-full flex-col items-center space-y-4 sm:items-end">
            <Transition show={showInfoBox}>
            <div className="pointer-events-auto w-full max-w-sm rounded-lg bg-white shadow-lg ring-1 ring-black/5 transition data-closed:opacity-0 data-enter:transform data-enter:duration-300 data-enter:ease-out data-closed:data-enter:translate-y-2 data-leave:duration-100 data-leave:ease-in data-closed:data-enter:sm:translate-x-2 data-closed:data-enter:sm:translate-y-0">
                <div className="p-4">
                <div className="flex items-start">
                    <div className="shrink-0">
                    <InformationCircleIcon aria-hidden="true" className="size-6 text-blue-400" />
                    </div>
                    <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">{infoMsg}</p>
                    </div>
                    <div className="ml-4 flex shrink-0">
                    <button
                        type="button"
                        onClick={() => {
                        setShowInfoBox(false)
                        }}
                        className="inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                    >
                        <span className="sr-only">Close</span>
                        <XMarkIcon aria-hidden="true" className="size-5" />
                    </button>
                    </div>
                </div>
                </div>
            </div>
            </Transition>
        </div>
    </div>
    )
}